import React, { useEffect, useState } from "react";
import Icons from "../../assets/images/index";
import { pagination, PaginationOption } from "../../components/common/utils/message";
import ReactPaginate from 'react-paginate';
import SelectBox from "../../components/common/formInput/SelectBox";
import { useDispatch } from "react-redux";
import { _status } from '../../components/common/utils/message';
import { listNotificatioSetting, updateNotificationSetting } from "../../services/notification.service";
import UpatedNotificationSetting from "./components/UpdateNoticficationSetting";
import { success, failed } from "../../components/common/Toastify";
import "./style.css";
import SendNotification from "./components/SendNotification";
const NotificationList = () => {

    const dispatch = useDispatch();

    const [resPayload, setResPayload] = useState([]);
    const [openForm, setOpenForm] = useState(false);
    const [openSendNotificationForm, setOpenSendNotificationForm] = useState(false);

    const [selectedMenu, setSelectedMenu] = useState(null);
    const totalPages = resPayload && resPayload.totalPages;

    const [limit, setLimit] = useState(pagination.limit);
    const [page, setPage] = useState(pagination.page);
    const [sortBy, setSortBy] = useState()
    const [order, setOrder] = useState(1)

    const handleClose = () => {
        setOpenForm(false);
        setSelectedMenu(null);
        _getListing();
    }
    const handleShow = () => setOpenForm(true);

    const handleNotificationModalClose = () => {
        setOpenSendNotificationForm(false);

    }
    const handleNotificationModalShow = () => setOpenSendNotificationForm(true);

    const openEditModal = (data) => {
        setSelectedMenu(data)
        handleShow();
    }

    useEffect(() => {
        _getListing();
    }, [dispatch]);

    /**
     * @description get all the RPC from db where page is pageChange and Limit for limit of the data.
     */
    const _getListing = () => {

        listNotificatioSetting({ page, limit, sortBy, order }, (data) => {
            setResPayload(data?.data?.docs)
        }, dispatch);
    }

    /**
     * @description /Function is on Page Change.
     * @param {param} param 
     */
    const handlePageChange = async (param) => {
        let currentPage = param.selected + 1;
        setPage(currentPage)
        await listNotificatioSetting({ page: currentPage, limit, sort: sortBy, order: order }, data => {
            setResPayload(data?.data?.docs)
        }, dispatch)
    };

    /**
     * @description Function For delete RPC.
     * @param {id} id 
     */


    /**
     * @description Function for show in dropdown entries with page option.
     * @param {param} displayPerPage 
     */
    const setPagination = async (displayPerPage) => {
        setLimit(displayPerPage);

        await listNotificatioSetting({ limit: displayPerPage, page }, data => {
            setResPayload(data?.data?.docs);
        }, dispatch)
    }

    /**
     * @description Function for get state by selected country
     * @param {param} val country
     */


    /**
     * @description Function for filter data with state fields.
     * @param {param} filterParam 
     */


    /**
    * @description Function for filter data with status fields.
    * @param {param} filterParam 
    */


    /**
    * @description Function for Search data with all fields.
    * @param {param} filterParam 
    */


    /**
    * @description Function for Search data with all fields.
    * @param {param} filterParam 
    */
    const _handleSorting = async (sortby, order) => {
        setSortBy(sortby);
        setOrder(order);
        await listNotificatioSetting({ limit: limit, page: page, sort: sortby, order: order }, response => {
            setResPayload(response.data.docs);
        }, dispatch)
    }
    const onSwitchHandle = (data) => {
        const payload = { ...data };
        payload.enabled = !payload.enabled;
        updateNotificationSetting({ ...payload }, (result) => {
            if (result.status === "SUCCESS" && result.code === 200) {
                success(result.message);
                _getListing();
            }
            else {
                failed(result.message);
            }
        }, dispatch)


    }
    return (
        <div className='dashboard-inner'>


            <div className='d-card'>
                <div className='d-card-header'>
                    <h5 className='d-card-heading d-card-sub-heading'>Notification Settings</h5>
                    <div className='d-card-actions'>
                        <button className='btn btn-blue' onClick={handleNotificationModalShow}>Send Notification</button>
                    </div>

                </div>

            </div>
            <div className="dashboard-table">
                <div className="responsive-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Serial <br /> No. </th>
                                <th><span className="sort-icon">Type</span></th>
                                <th><span className="sort-icon">Title</span></th>
                                <th><span className="sort-icon">Notification Content</span></th>
                                <th>Status</th>
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {resPayload?.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.type}</td>
                                    <td>{item.title}</td>
                                    <td>{item.notification_content}</td>
                                    <td
                                    // className={item.enabled ? "text-success" : "text-danger"}
                                    >
                                        {/* {item.enabled ? "Active" : "Inactive"} */}
                                        <label className="switch">
                                            <input type="checkbox" checked={item.enabled} onChange={() => onSwitchHandle(item)} />
                                            <span className="slider round"></span>
                                        </label>


                                    </td>
                                    <td className="text-center">
                                        <span className="sort-icon">
                                            <button className="dashboard-action" title="Edit" onClick={() => openEditModal(item)}>
                                                <img src={Icons.edit} alt="" />
                                            </button>
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {resPayload?.length === 0 ? (<h5 className="d-flex align-items-center justify-content-center">No data found!</h5>) : null}
                </div>

            </div>
            {
                openForm && selectedMenu &&
                <UpatedNotificationSetting
                    show={openForm}
                    handleClose={handleClose}
                    setting={selectedMenu}
                />
            }{
                openSendNotificationForm && <SendNotification handleClose={handleNotificationModalClose} show={openSendNotificationForm} />
            }
        </div>
    )
}

export default NotificationList

